// extracted by mini-css-extract-plugin
export default {"detailsTab":"ZuYjRiD0yP0q5kLNaYWJ","detailsTabFieldCaption":"MaIYoVx7gkVLMPvD382k"};